// service/utils/mouvementFinancierUtils.js
/**
 * Formate le montant avec séparateurs de milliers
 * @param {number} amount 
 * @returns {string}
 */
export const formatMontant = (amount) => {
  if (amount === undefined || amount === null) return '0';
  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

/**
 * Formate la quantité avec séparateurs de milliers
 * @param {number} quantity 
 * @returns {string}
 */
export const formatQuantite = (quantity) => {
  if (quantity === undefined || quantity === null) return '0';
  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(quantity);
};

/**
 * Formate la date pour l'affichage
 * @param {string} dateString 
 * @returns {string}
 */
export const formatDateMouvement = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

/**
 * Détermine la classe CSS pour la catégorie
 * @param {string} categorie 
 * @returns {string}
 */
export const getCategorieClass = (categorie) => {
  const classes = {
    'Commission Trimestrielle': 'bg-warning bg-opacity-10 text-warning',
    'Cash': 'bg-success bg-opacity-10 text-success',
    'Achat Titre': 'bg-info bg-opacity-10 text-info',
    'Vente Titre': 'bg-primary bg-opacity-10 text-primary',
    'Retrait': 'bg-danger bg-opacity-10 text-danger',
    'Dépôt': 'bg-success bg-opacity-10 text-success'
  };
  
  return classes[categorie] || 'bg-secondary bg-opacity-10 text-secondary';
};

/**
 * Applique les filtres et tris aux mouvements
 * @param {Array} mouvements 
 * @param {Object} filters 
 * @returns {Array}
 */
export const filterAndSortMouvements = (mouvements, filters = {}) => {
  let filtered = [...mouvements];

  // Filtre par compte
  if (filters.accountName) {
    filtered = filtered.filter(m => 
      m.accountName?.toLowerCase().includes(filters.accountName.toLowerCase())
    );
  }

  // Filtre par titre
  if (filters.securityName) {
    filtered = filtered.filter(m => 
      m.securityName?.toLowerCase().includes(filters.securityName.toLowerCase())
    );
  }

  // Filtre par catégorie
  if (filters.categorie) {
    filtered = filtered.filter(m => m.categorie === filters.categorie);
  }

  // Tri par date
  if (filters.sortOrder === 'date_desc') {
    filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
  } else if (filters.sortOrder === 'date_asc') {
    filtered.sort((a, b) => new Date(a.date) - new Date(b.date));
  }

  // Tri par montant
  if (filters.sortOrder === 'montant_desc') {
    filtered.sort((a, b) => (b.lastValue || 0) - (a.lastValue || 0));
  } else if (filters.sortOrder === 'montant_asc') {
    filtered.sort((a, b) => (a.lastValue || 0) - (b.lastValue || 0));
  }

  return filtered;
};

/**
 * Extrait les catégories uniques pour les filtres
 * @param {Array} mouvements 
 * @returns {Array}
 */
export const extractUniqueCategories = (mouvements) => {
  const categories = new Set();
  mouvements.forEach(m => {
    if (m.categorie) {
      categories.add(m.categorie);
    }
  });
  return Array.from(categories).sort();
};